// Lee los ids de tipos de pregunta.
export function typeIds(module: any) {
    const ids: string[] = [];
    for (const type of (module.questionTypes || [])) ids.push(type.id);
    return ids;
}

// Clona las filas de niveles.
export function cloneLevels(module: any) {
    const rows: any[] = [];
    for (const level of (module.levels || [])) rows.push(cloneLevel(level));
    return rows;
}

// Clona una fila de nivel.
export function cloneLevel(level: any) {
    return { ...level };
}

// Lee los ids de grupos del módulo.
export function groupIds(module: any) {
    const ids: string[] = [];
    for (const link of (module.groupModules || [])) addGroupId(link, ids);
    return ids;
}

// Agrega el id de grupo de un vínculo.
export function addGroupId(link: any, ids: string[]) {
    const id = groupLinkId(link);
    if (id) ids.push(id);
}

// Lee el id de grupo de un vínculo.
export function groupLinkId(link: any) {
    if (link.groupId) return link.groupId;
    return refId(link.group);
}

// Lee el id de una referencia.
export function refId(group: any) {
    if (group) return group.id;
    return null;
}

// Moldea valores del formulario.
export function moduleValues(module: any) {
    return {
        id: module.id,
        name: module.name,
        acronym: module.acronym,
        routeName: routeOf(module),
        description: module.description,
        enabled: module.enabled,
        evaluateAllMonths: module.evaluateAllMonths,
        scoringMode: scoringOf(module),
    };
}

// Resuelve el nombre de ruta.
export function routeOf(module: any) {
    return module.routeName || module.acronym;
}

// Resuelve el modo de puntaje.
export function scoringOf(module: any) {
    return module.scoringMode || 'monthly';
}

// Arma el payload del módulo.
export function modulePayload(raw: any, types: string[], levels: any[], groups: string[]) {
    const payload = basePayload(raw, types);
    payload.levels = levelRows(levels);
    payload.groups = groupRows(groups);
    return withRoute(payload);
}

// Arma la base del payload.
export function basePayload(raw: any, types: string[]) {
    return { ...raw, questionTypeIds: [...types] };
}

// Moldea las filas de niveles.
export function levelRows(levels: any[]) {
    const rows: any[] = [];
    for (const level of levels) rows.push(levelRow(level));
    return rows;
}

// Moldea una fila de nivel.
export function levelRow(level: any) {
    return {
        minPercent: level.minPercent,
        maxPercent: level.maxPercent,
        label: level.label,
        color: level.color
    };
}

// Moldea las filas de grupos.
export function groupRows(groups: string[]) {
    const rows: any[] = [];
    for (const id of groups) rows.push({ groupId: id });
    return rows;
}

// Normaliza la ruta del payload.
export function withRoute(payload: any) {
    payload.routeName = routeValue(payload.routeName);
    return payload;
}

// Resuelve el valor de ruta.
export function routeValue(routeName: string) {
    if (clean(routeName)) return clean(routeName);
    return null;
}

// Recorta el texto opcional.
export function clean(routeName: string) {
    if (routeName) return routeName.trim();
    return '';
}
